<template>
  <b-tab>
    <template #title>
      <feather-icon
          icon="ImageIcon"
          size="21"
      />
      <strong>
        Fotóalbumok
      </strong>
    </template>

    <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
    >
      <b-row>
        <b-col cols="12">
          <gallery-list :user-id="entityId"></gallery-list>
        </b-col>
      </b-row>
    </b-overlay>
  </b-tab>
</template>

<script>
import {
  BTab,
  BBadge,
  BRow,
  BCol,
  BButton,
  BFormFile,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupText,
  BOverlay,
  BForm,
  BLink,
} from 'bootstrap-vue'
import GalleryList from "../../../../gallery/List.vue"

export default {
  components: {
    BTab,
    BBadge,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupText,
    BOverlay,
    BForm,
    BLink,
    GalleryList
  },
  props: {
    entityId: {
      type: Number,
      required: false
    },
  },
  data() {
    return {
      loading: false,
    }
  }
}
</script>
